export default defineNuxtPlugin(() => {
  return {
    provide: {
      pluralize: (
        amount: number,
        singular: any,
        plural: any,
        includeNumber = true,
      ) => {
        const response = amount > 1 || amount === 0 ? plural : singular
        if (includeNumber) return `${amount} ${response}`
        return response
      },

      sentenceCase: (string: string): string =>
        string?.replace(/(^(\w)|\s(\w))/g, (x) => x.toUpperCase()),

      fromSlug: (str?: string): string =>
        str
          ? str
              .replace(/(^\w)/g, (g) => g[0].toUpperCase())
              .replace(/([-_]\w)/g, (g) => ' ' + g[1].toUpperCase())
              .trim()
          : '',

      capitalize: (str: string): string => str.toUpperCase(),

      isEmpty: (str: string): boolean => !str.trim().length,

      firstLetter: (value: string): string => value[0].toUpperCase(),

      words: (value: string, words: number = 100, end: string = '...'): string => {
        const regex = new RegExp(`^\\s*(?:\\S+\\s+){1,${words}}`, 'u')
        const matches = value.match(regex)

        if (!matches || value.length === matches[0].length) {
          return value
        }

        return matches[0].trimEnd() + end
      },
    },
  }
})
